import { ReactElement, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import cs from 'classnames';
import getRoutes from 'routes';

import AppHeader from 'components/AppHeader/AppHeader';
import Breadcrumbs from 'components/Breadcrumbs';
import CreateJobButton from 'components/CreateJobButton/CreateJobButton';
import Footer from 'components/Footer/Footer';
import PageTitle from 'components/PageTitle';
import Sidebar from 'components/Sidebar';
import GuideModal from 'components/Tour/GuideModal/GuideModal';
import TourContainer from 'components/Tour/TourContainer/TourContainer';

import {
  selectIsShowGuide // selectIsShowWelcomeScreen
} from 'features/auth/authSelectors';

import { useAppSelector } from 'hooks/useTypedRedux';

import { LayoutProps, RouteObject } from 'types/route';

import styles from './styles.module.scss';

const BaseLayout = ({ children }: LayoutProps): ReactElement => {
  const { pathname } = useLocation();
  const routes = getRoutes();
  // const isShowGuide = useAppSelector(selectIsShowGuide);
  const isShowGuide = false;

  const [isShowGuideModal, setIsShowGuideModal] = useState<boolean>(true);

  const currentRoute = useMemo(
    () => routes.find((route: RouteObject) => route.path === pathname),
    [pathname, routes]
  );

  const rightSideComponent = useMemo(() => {
    switch (pathname) {
      case '/jobs':
        return <CreateJobButton />;
      default:
        return null;
    }
  }, [pathname]);

  useEffect(() => {
    setIsShowGuideModal(true);
  }, [isShowGuide]);

  const handleCloseGuide = () => {
    setIsShowGuideModal(false);
  };

  return (
    <>
      <TourContainer />
      <Layout className={cs(currentRoute?.key, styles.container)}>
        <AppHeader />
        <div className={styles.pageHeader}>
          <div className="header-title-container">
            <PageTitle />
            <Breadcrumbs />
          </div>
          {rightSideComponent}
        </div>
        <Content>{children}</Content>
        <Footer />
      </Layout>
      <Sidebar />
      {isShowGuideModal && (
        <GuideModal onClose={handleCloseGuide} isOpen={isShowGuide} />
      )}
    </>
  );
};

export default BaseLayout;
